export default {
    init() {
        this.prepareTabs();
        this.bindEvents();
    },

    prepareTabs() {
        $(".js-pricing-tabs").each(function () {
            const container = $(this);

            container.find(".js-tab-panel").removeClass("hidden").each(function (index) {
                $(this).toggleClass("is-mobile-hidden", index !== 0);
            });
        });
    },

    bindEvents() {
        $(document).on("click", ".js-pricing-tabs .js-tab-btn", function () {
            const button = $(this);
            const container = button.closest(".js-pricing-tabs");
            const tab = button.data("tab");

            container.find(".js-tab-btn").each(function () {
                const current = $(this);
                const isActive = current.data("tab") === tab;

                current.toggleClass("bg-blue-dark text-white", isActive);
                current.toggleClass("bg-gray text-black", !isActive);
            });

            container.find(".js-tab-panel").each(function () {
                const panel = $(this);
                panel.toggleClass("is-mobile-hidden", panel.data("tab") !== tab);
            });
        });
    },
};
